<div
        *ngIf="loading | async"
        class="spinner-container">
    <div class="spinner-container__backdrop">
    </div>
    <div class="spinner-container__loading"></div>
</div>